export const CONNECT_TABS = [
  { value: 'setup', label: 'Setup' },
  { value: 'uses', label: 'What you can do' },
]

/** The official Mini Course Generator app in ChatGPT. */
export const CHATGPT_APP_URL =
  'https://chatgpt.com/plugins/plugin_asdk_app_69b58bc3d5088191813aa1ec093f6c4f'

/** Screen recording of connecting an AI tool, from copying the URL on. */
const SETUP_VIDEO_URL = 'https://www.youtube.com/live/CkzBXUA6qBA?t=322'

/**
 * ChatGPT first (it opens on it): it connects through the official app, so
 * it has an "Add to ChatGPT" button and the path to it (`path`) instead of a
 * video and an MCP URL to paste. Claude and Manus add a custom connector.
 */
export const AI_TOOLS = [
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    appUrl: CHATGPT_APP_URL,
    path: ['ChatGPT', 'Plugins', 'Mini Course Generator', 'Connect'],
    steps: [
      {
        title: 'Open Mini Course Generator in ChatGPT',
        description:
          'Click Add to ChatGPT, or in ChatGPT open Plugins (chatgpt.com/plugins) and search for Mini Course Generator.',
      },
      {
        title: 'Connect and sign in',
        description:
          'Select Connect, sign in to Mini Course Generator and pick your workspace.',
      },
      {
        title: 'Use it in a chat',
        description:
          'Type @Mini Course Generator in any chat, or choose it from + then More. Try: "@Mini Course Generator list my courses."',
      },
    ],
  },
  {
    id: 'claude',
    name: 'Claude',
    videoUrl: SETUP_VIDEO_URL,
    steps: [
      {
        title: 'Open connectors',
        description:
          'In Claude, click Customize, then Connectors. You can also go straight to claude.ai/settings/connectors.',
      },
      {
        title: 'Add custom connector',
        description:
          'Click the plus button next to Connectors and choose Add custom connector.',
      },
      {
        title: 'Paste MCP URL',
        description: 'Paste the Mini Course Generator MCP URL.',
        showUrl: true,
      },
      {
        title: 'Authorize and try it',
        description:
          'Click Add, sign in, pick your workspace, and authorize access. Then try: "In Mini Course Generator, list my courses."',
      },
    ],
  },
  {
    id: 'manus',
    name: 'Manus',
    videoUrl: SETUP_VIDEO_URL,
    steps: [
      {
        title: 'Open connectors',
        description: 'In Manus, open Settings and go to Connectors.',
      },
      {
        title: 'Add custom MCP',
        description: 'Choose Add connector, then Custom MCP.',
      },
      {
        title: 'Paste MCP URL',
        description: 'Name it Mini Course Generator and paste the MCP URL.',
        showUrl: true,
      },
      {
        title: 'Sign in and use it',
        description:
          'Complete the sign-in, pick your workspace, then ask Manus to list your courses.',
      },
    ],
  },
]

export const AI_USES = [
  {
    icon: 'tabler:file-plus',
    title: 'Create courses from your files',
    description: 'Turn a PDF, document or meeting notes into a course.',
    prompts: [
      'Create a 5-page course on our expense policy from this PDF',
      'Turn these meeting notes into a quick onboarding course',
    ],
  },
  {
    icon: 'tabler:pencil',
    title: 'Update existing courses',
    description:
      'Edit text, add quizzes or translate a course without opening the editor.',
    prompts: [
      'Add a 3-question quiz to the last section of Security basics',
      'Translate Onboarding essentials into German',
    ],
  },
  {
    icon: 'tabler:route',
    title: 'Build learning paths',
    description: 'Group courses into an ordered path for a team or role.',
    prompts: [
      'Create a learning path for new sales hires from our existing courses',
      'Add Compliance 2026 to the Manager path',
    ],
  },
  {
    icon: 'tabler:chart-bar',
    title: 'Ask about your learners',
    description: 'Get answers on enrollments, completion and quiz scores.',
    prompts: [
      'Which section of Onboarding essentials loses the most learners?',
      'Who has not started Compliance 2026 yet?',
    ],
  },
]
